import { Timestamp } from '@britishcouncil/common-core';
import { api, OdpMonitoringReportRecordDto, PagedResultOfOdpMonitoringReportRecordDto } from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { OdpMonitoringReportFilterType } from './odpMonitoringReportTypes';
import { getPaginationParameters, getQueryStringParameters } from 'utils';

type ReportParams = TableState<OdpMonitoringReportRecordDto, OdpMonitoringReportFilterType>;

const mapQueryParams = (params: ReportParams) => {
  if (params.filters.date?.[0] == undefined || params.filters.date[1] == undefined) {
    throw new Error('From and To dates are required');
  }

  return {
    ...getPaginationParameters(params),
    filter: {
      from: Timestamp.toISOString(params.filters.date[0]),
      to: Timestamp.toISOString(params.filters.date[1]),
      examinerNumber: params.filters.examinerNumber ?? '',
      reasons: params.filters.reasons ?? [],
      results: params.filters.results ?? [],
      stages: params.filters.stages ?? [],
      showDeleted: params.filters.showDeleted ?? false,
    },
  };
};

export const odpMonitoringReportApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getOdpMonitoringReportRecords: builder.query<
      PagedResultOfOdpMonitoringReportRecordDto,
      ReportParams
    >({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.odpMonitoringReport.getOdpMonitoringReport(input);
      },
      providesTags: ['OdpMonitoring'],
    }),
    generateOdpMonitoringReportPdfReport: builder.mutation<File, ReportParams>({
      query: async (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.odpMonitoringReport.getOdpMonitoringPdfReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
    generateOdpMonitoringReportExcelReport: builder.mutation<File, ReportParams>({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.odpMonitoringReport.getOdpMonitoringExcelReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
  }),
});

export const {
  useGetOdpMonitoringReportRecordsQuery,
  useGenerateOdpMonitoringReportPdfReportMutation,
  useGenerateOdpMonitoringReportExcelReportMutation,
} = odpMonitoringReportApi;
